// Taken from https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver

// Select the node that will be observed for mutations
const targetNode = document.getElementById('body');

// Options for the observer (which mutations to observe)
const config = { childList: true };

export const hubSpot = {
  containerId: 'hubspot-messages-iframe-container',
};

function setHubSpotBackgroundTransparent() {
  const hubSpotDiv = document.getElementById(hubSpot.containerId);
  if (hubSpotDiv) {
    const [shadowDiv] = Array.from(hubSpotDiv.children);
    shadowDiv.classList.remove('shadow', 'visible');
  }
}

export function toggleHubSpotVisibility(node: any) {
  return window.location.pathname.includes('/ceo')
    ? node.setAttribute('class', 'hubSpot-show')
    : node.setAttribute('class', 'hubSpot-hide');
}

// Callback function to execute when mutations are observed
const callback = (mutationsList: any[]) => {
  const mutationsArr = Array.from(mutationsList);
  mutationsArr.forEach(mutation => {
    if (mutation.type === 'childList' && mutation.addedNodes.length) {
      const {
        addedNodes: [firstNode],
      } = mutation;
      if (firstNode.id === hubSpot.containerId) {
        // John: Uncomment if hubspot should be left justified
        // setHubSpotBackgroundTransparent();
        toggleHubSpotVisibility(firstNode);
      }
    }
  });
};

// Create an observer instance linked to the callback function
const observer = new MutationObserver(callback);

export function startHubSpotObserver() {
  // Start observing the target node for configured mutations
  if (targetNode) {
    observer.observe(targetNode, config);
  }
}

export default startHubSpotObserver;
